export const UNIT_MANAGE_GRID_CONFIG_ID = 'unit-dash-unit-manage'

export const UNIT_MANAGE_GRID_CONFIG = {
  id: UNIT_MANAGE_GRID_CONFIG_ID,
  layout: {
    xxl: { i: UNIT_MANAGE_GRID_CONFIG_ID, x: 0, y: 0, w: 3.25, h: 3.15, static: true },
    xl: { i: UNIT_MANAGE_GRID_CONFIG_ID, x: 0, y: 0, w: 4, h: 3.15, static: true },
    lg: { i: UNIT_MANAGE_GRID_CONFIG_ID, x: 0, y: 0, w: 4.5, h: 3.35, static: true },
    md: { i: UNIT_MANAGE_GRID_CONFIG_ID, x: 0, y: 0, w: 5, h: 3.25, static: true },
    sm: { i: UNIT_MANAGE_GRID_CONFIG_ID, x: 0, y: 0, w: 5.75, h: 3.25, static: true },
    xs: { i: UNIT_MANAGE_GRID_CONFIG_ID, x: 0, y: 0, w: 6.5, h: 3.2, static: true },
    xxs: { i: UNIT_MANAGE_GRID_CONFIG_ID, x: 0, y: 0, w: 12, h: 1.75, static: true }
  }
}
